import { Card, CardContent, Divider, List, ListItemButton, Stack, Typography } from '@mui/joy'
import { PageBase } from 'app/components/Common/PageBase'
import { PageBodyContainer } from 'app/components/Common/PageBodyContainer'
import { headDocumentation } from './utils/headDocumentation'
import useDocumentationPage from './utils/useDocumentationPage'
import Markdown from 'app/components/Markdown/Markdown'

type Props = {}


const DocumentationPage = (props: Props) => {

  const {
    images,
    activeScreen,
    setActiveScreen,
  } = useDocumentationPage({})

  return (
    <PageBase>
      <PageBodyContainer size='full' sx={{overflow: 'auto', p: 'unset', py: 'unset'}}>
        <Stack sx={{ display: 'grid', gridTemplateColumns: {xs: '1fr', md: 'auto 1fr'}, gap: {xs: 0, md: 4}, overflow: 'auto', py: 'unset' }}>
          <Card sx={{
            overflow: 'auto',
            background: "#F4F7FF",
            boxShadow: "0px 4px 4px #BACAF2",
            borderRadius: "12px",
            m: 2,
          }}>
            <CardContent>
              <Typography level='h3' sx={{color: '#1B316C'}}>Guidelines</Typography>
              <Divider/>
              <List sx={{gap: 1, flexDirection:{xs: 'row', md: 'column'}}}>
                {
                  headDocumentation?.lists.map((item, index) => {

                    const isActive = activeScreen == index

                    return (
                      <ListItemButton variant={isActive ? 'solid' : 'plain'} sx={{ borderRadius: 8, backgroundColor: isActive ? '#D2DFFF' : 'initial', '&:hover':{backgroundColor: 'white !important'} }} onClick={() => setActiveScreen(index)}>
                        <Typography sx={isActive ? { fontWeight: 600, color: '#1B316C' } : { fontWeight: 500, color: '#1B316C' }}>{item.name}</Typography>
                      </ListItemButton>
                    )

                  })
                }
              </List>
            </CardContent>
          </Card>
          <Stack sx={{ overflow: 'auto', pb: 4, px: {xs: 3, md: 0} }}>
            {
              headDocumentation?.lists.map((item, index) => {

                return (
                  <Stack
                    sx={{
                      display: activeScreen == index ? 'initial' : 'none',
                      '& ul': {
                        mt: 0,
                        mb: 4,
                      }
                    }}
                  >
                    <Markdown
                      content={item.content}
                      images={images}
                    />
                  </Stack>
                )

              })
            }
          </Stack>
        </Stack>
      </PageBodyContainer>
    </PageBase>
  )
}

export default DocumentationPage